import React from 'react';

import './ErrorBoundary.scss';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
    this.handleReload = () => {
      window.location.reload();
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  // React requires this lifecycle method to be an instance method.
  // eslint-disable-next-line class-methods-use-this, no-console
  componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.error('Unhandled application error:', error, errorInfo);
  }

  render() {
    const { hasError, error } = this.state;

    if (hasError) {
      const developmentMessage = process.env.NODE_ENV === 'development' && error?.message;

      return (
        <main className="error-boundary" role="alert">
          <section className="error-boundary-card" aria-labelledby="error-boundary-title">
            <div className="error-boundary-mark" aria-hidden="true">
              !
            </div>
            <p className="error-boundary-eyebrow">Admin application</p>
            <h1 id="error-boundary-title">Something went wrong</h1>
            <p className="error-boundary-message">
              The application ran into an unexpected problem. Reload the page to try again.
            </p>
            {developmentMessage && <p className="error-boundary-details">{developmentMessage}</p>}
            <button type="button" className="error-boundary-action" onClick={this.handleReload}>
              Reload application
            </button>
          </section>
        </main>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
